import { alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SearchBarVariant } from '@prismamedia/one-components';

export const MULTIMEDIA_MANAGER_SEARCH_BLOCK_HEIGHT = 130;

export const useStyles = makeStyles((theme) => ({
  iconButton: {
    color: theme.palette.action.active,
    transform: 'scale(1, 1)',
    transition: theme.transitions.create(['transform', 'color'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  iconButtonHidden: {
    transform: 'scale(0, 0)',

    '& > $icon': {
      opacity: 0,
    },
  },
  input: {
    width: '100%',
  },
  paperSearch: {
    alignItems: 'center',
    height: theme.spacing(6),
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(1),
  },
  searchContainer: {
    margin: 'auto 16px',
    width: `calc(100% - ${theme.spacing(6 + 4)})`,
  },
  wrapper: {
    backgroundColor: theme.palette.grey[100],
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingRight: theme.spacing(1),
    height: '90px',
    zIndex: 2,
    position: 'sticky',
    top: '0px',
  },
  icon: () => ({
    color: alpha(theme.palette.common.black, 0.54),
    '&:hover': {
      backgroundColor: SearchBarVariant.PRIMARY
        ? undefined
        : alpha(theme.palette.common.black, 0.04),
    },
  }),
  manageSearchIcon: { fontSize: '30px' },
}));
